import { useEffect, useState } from "react";
import { FaBed, FaAddressCard, FaDollarSign } from "react-icons/fa";

const API_BASE = process.env.REACT_APP_API_URL + "/api";

export default function Search() {
    const [listings, setListings] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [city, setCity] = useState("");
    const [zip, setZip] = useState("");
    const [maxPrice, setMaxPrice] = useState("");
    const [bedrooms, setBedrooms] = useState("");

    // Fetch listings from API
    useEffect(() => {
        fetch(`${API_BASE}/listings`)
            .then((res) => res.json())
            .then((data) => {
                setListings(data);
                setFiltered(data);
            })
            .catch((err) => console.error("Error fetching listings:", err));
    }, []);

    // Search handler
    const handleSearch = () => {
        let results = [...listings];

        if (city.trim()) {
            results = results.filter((l) =>
                l.city?.toLowerCase().includes(city.toLowerCase())
            );
        }

        if (zip.trim()) {
            results = results.filter((l) =>
                l.zip?.includes(zip)
            );
        }

        if (maxPrice) {
            results = results.filter((l) =>
                l.base_price !== undefined &&
                Number(l.base_price) <= Number(maxPrice)
            );
        }

        if (bedrooms) {
            results = results.filter(
                (l) => Number(l.bedrooms) >= Number(bedrooms)
            );
        }

        setFiltered(results);
    };

    return (
        <div className="search-page">

            {/* Search Bar */}
            <div className="search-hero">
                <h1>Find the Right Adult Family Home</h1>

                <div className="search-bar">

                    {/* City */}
                    <input
                        type="text"
                        placeholder="Search by city..."
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                    />

                    {/* ZIP */}
                    <input
                        type="text"
                        placeholder="Search by ZIP..."
                        value={zip}
                        onChange={(e) => setZip(e.target.value)}
                    />

                    {/* Max Base Price */}
                    <input
                        type="number"
                        placeholder="Max Base Price ($)"
                        value={maxPrice}
                        onChange={(e) => setMaxPrice(e.target.value)}
                    />

                    {/* Bedrooms */}
                    <select
                        value={bedrooms}
                        onChange={(e) => setBedrooms(e.target.value)}
                    >
                        <option value="">Bedrooms</option>
                        <option value="1">1+</option>
                        <option value="2">2+</option>
                        <option value="3">3+</option>
                        <option value="4">4+</option>
                    </select>

                    <button onClick={handleSearch}>Search</button>
                </div>
            </div>

            {/* Results Grid */}
            <div className="results-grid">
                {filtered.length > 0 ? (
                    filtered.map((listing) => (
                        <div key={listing.id} className="listing-card">
                            <div className="listing-body">

                                <h3>{listing.title}</h3>

                                <p><FaAddressCard /> {listing.address}, {listing.city} {listing.state}
                                </p>

                                <p><FaBed /> {listing.bedrooms || 0} Bedrooms</p>

                                {/* Base Price */}
                                <p className="price"><FaDollarSign /> {Number(listing.base_price || 0).toLocaleString()}
                                    <span className="per-month"> / month</span>
                                </p>

                                <button
                                    onClick={() =>
                                        window.location.href = `/listing/${listing.id}`
                                    }
                                >
                                    View Details
                                </button>

                            </div>
                        </div>
                    ))
                ) : (
                    <p>No listings found.</p>
                )}
            </div>

        </div>
    );
}